




































































import Loading from '@/app/components/Common/Loading.vue'
/* api */
import GetCamImgApi from '@/app/model/api/getCamImgApi'
/* module */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component({
  components: {
    Loading
  }
})
export default class FieldImg extends Vue {
  private showImgModal: boolean = false;
  private showLoading: boolean = false;
  private noImgPath: string = require('@/assets/img/no_image.svg')
  private originalImagePath: string = ''
  private displayImg: string = require('@/assets/img/no_image.svg')
  private observer: any = null

  @Prop() private id!: number

  @Watch('id')
  onChangeImgData () {
    this.getDefaultImg()
  }

  mounted () {
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (entry && entry.isIntersecting) {
        // 画像取得
        this.getDefaultImg()
        // 監視対象から外す
        const fieldImg: any = this.$refs.fieldImg
        this.observer.unobserve(fieldImg)
      }
    })
    // 監視対象にセット
    const fieldImg: any = this.$refs.fieldImg
    this.observer.observe(fieldImg)
  }

  private async getDefaultImg () {
    this.displayImg = this.noImgPath
    if (this.id !== 0) {
      this.showLoading = true
      const result = await GetCamImgApi.getCamImgData(this.id, 'thumbnail')

      if (typeof result === 'string') {
        this.displayImg = String(result)
      } else {
        this.displayImg = this.noImgPath
      }
      this.showLoading = false
    }
  }
}
